import React from "react";
import "../../assets/css/como-participar.css";
import icon1 from "../../assets/02_Assets/icon-1.svg";
import icon2 from "../../assets/02_Assets/icon-2.svg";
import icon3 from "../../assets/02_Assets/icon-3.svg";

const ComoParticiparComponent: React.FC = () => {
  return (
    <section className="como-participar-section">
      <div className="como-participar-bg">
        <div className="como-participar-bg-right"></div>
      </div>
      
      <div className="como-participar-container">
        
        <h2 className="como-participar-title">¿Cómo participar?</h2>
        <p className="como-participar-subtitle">
          Sigue estos 3 pasos y podrás estar en la Copa Mundial de la FIFA 2026™
        </p>
        
        <div className="como-participar-cards">
          
          {/* Card 1 */}
          <div className="como-participar-card">
            <div className="como-participar-icon">
              <img src={icon1} alt="Paso 1" />
            </div>
            <p className="como-participar-card-text">
              Realiza un Test Drive y compra tu HYUNDAI.
            </p>
          </div>

          {/* Card 2 */}
          <div className="como-participar-card">
            <div className="como-participar-icon">
              <img src={icon2} alt="Paso 2" />
            </div>
            <p className="como-participar-card-text">
              2. Patea el balón en el evento final.
            </p>
          </div>

          {/* Card 3 */}
          <div className="como-participar-card">
            <div className="como-participar-icon">
              <img src={icon3} alt="Paso 3" />
            </div>
            <p className="como-participar-card-text">
              3. Haz gol por la ventana y llegas a la ultima ronda, te vas a la Copa Mundial de la FIFA 2026™
            </p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default ComoParticiparComponent;
